module.exports = __webpack_public_path__ + "a21d3c630e856b5fb26fd3d6f1b894ff.svg";